import { handleAPI, API_VERSION_ONE } from '../../../itrust_common/utils/apiUtils';

export function previousReportsLoad(filters) {
  const url = `/${API_VERSION_ONE}/reports`;
  const method = 'GET'

  return {
    type: 'PREVIOUS_REPORTS_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function previousReportLoad(id, filters) {
  const url = `/${API_VERSION_ONE}/reports/${id}`;
  const method = "GET"
  return {
    type: 'PREVIOUS_REPORT_LOAD',
    payload: handleAPI(url, filters, method)
  }
}